import { NULL } from "sass";

export default{
    mensajes: [],
    mensajeSelec: null,
}